module.exports = __webpack_public_path__ + "img/Com-bilbio@2x-100.aa90704e.jpg";